import React, { useContext, useEffect, useState } from 'react';
import { AppSettings } from '../../config/app-settings';
import Loader from '../pages/loader';
import EditCreateVideoDuration from '../../components/video/EditCreateVideoDuration';
import ReusableTable from '../../components/other/ReuseableTable';
import { useListVideosDurationQuery } from '../../redux/Api/VideoApiSlice';
import { can } from '../../helpers/auth';
import NoPermission from '../pages/noPermission';
import { toast } from 'react-toastify';

function VideoDurations() {
	const [pagination, setPagination] = useState({
		current: 1,
		pageSize: 10
	})

	const { data: videosDuration, isLoading, error, isFetching } = useListVideosDurationQuery({
		page: pagination.current,
		page_size: pagination.pageSize,
		ordering: 'id',
	});
	const [edit, setEdit] = useState(false)
	const [create, setCreate] = useState(false)
	const [holder, setHolder] = useState()

	useEffect(() => {
		if (error?.data) {
			const errorMessages = Object.values(error.data).flat()
			errorMessages.forEach(message => {
				toast.error(message)
			})
		}
	}, [error])

	function formatTimestamp(timestamp) {
		const date = new Date(timestamp);

		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	}

	let columns = [
		{ title: "ID", dataIndex: "id", key: "id", sorter: true },
		{
			title: 'Duration',
			dataIndex: 'duration',
			key: 'duration',
			sorter: true,
			search: true,
		},

		{
			title: 'Updated At',
			dataIndex: 'updated_at',
			key: 'updated_at',
			render: (text) => (formatTimestamp(text)),
		},
		{
			title: 'Created At',
			dataIndex: 'created_at',
			key: 'created_at',
			render: (text) => (formatTimestamp(text)),
		},

	];

	if (can("change_videoduration")) {
		columns.push({
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<div className='flex gap-2'>
					<button className='btn btn-outline-theme' onClick={() => handleEdit(record)}>Edit</button>
				</div>
			),
		})
	}

	const handleEdit = (record) => {
		setHolder(record)
		setEdit(true)
	};

	const handleTableChange = paginationInfo => {
		setPagination({
			current: paginationInfo.current,
			pageSize: paginationInfo.pageSize
		})
	}

	const context = useContext(AppSettings);
	useEffect(() => {
		context.setAppHeaderNone(false);
		context.setAppSidebarNone(false);
		context.setAppContentClass('');
		context.setAppThemePanal(true)

		return function cleanUp() {
			context.setAppHeaderNone(true);
			context.setAppSidebarNone(true);
			context.setAppContentClass('p-0');
			context.setAppThemePanal(false)
		};
	}, []);

	if (!can("view_videoduration")) {
		return <NoPermission />
	}

	return (
		<div className='w-full flex flex-col'>
			<Loader isLoading={isLoading || isFetching} />
			{edit ? <EditCreateVideoDuration state={"edit"} open={edit} setOpen={setEdit} videoDuration={holder} /> : null}
			{create ? <EditCreateVideoDuration state={"create"} open={create} setOpen={setCreate} videoDuration={null} /> : null}
			<button className='btn btn-outline-theme ml-auto' onClick={() => setCreate(true)}>Add New Video Duration</button>
			<br />
			{videosDuration ? (
				<ReusableTable
					columns={columns}
					data={ videosDuration?.results}
					pagination={{
						current: pagination.current,
						pageSize: pagination.pageSize,
						total: videosDuration?.count,
						showSizeChanger: true
					}}
					onChange={handleTableChange}
				/>
			) : null}
		</div>
	)
}

export default VideoDurations;
